import { render, staticRenderFns } from "./OwnerKeysPage.vue?vue&type=template&id=3448053a"
import script from "./OwnerKeysPage.vue?vue&type=script&lang=js"
export * from "./OwnerKeysPage.vue?vue&type=script&lang=js"
import style0 from "./OwnerKeysPage.vue?vue&type=style&index=0&id=3448053a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports